/** Yahoo's own hosted brand asset, used as published rather than copied into the repo. */
const YAHOO_FANTASY_LOGO_URL =
  "https://763445962456-brand-assets.s3.us-west-2.amazonaws.com/brandwebsite/s3fs-public/Yahoo_Fantasy.svg";

/**
 * "Fantasy data provided by Yahoo Fantasy" with the Yahoo Fantasy wordmark.
 * The wordmark is part purple and part black, so it sits on a white chip
 * rather than being recoloured for the dark theme; the chip also crops the
 * SVG's large square padding down to the wordmark (see .yahoo-attribution
 * in app.css).
 */
export function YahooAttribution() {
  return (
    <span className="yahoo-attribution">
      <span className="yahoo-attribution__logo">
        <img src={YAHOO_FANTASY_LOGO_URL} alt="Yahoo Fantasy" loading="lazy" referrerPolicy="no-referrer" />
      </span>
      <span>Fantasy data provided by Yahoo Fantasy</span>
    </span>
  );
}
